<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-text-field
          id="taxCommentCommentCode"
          class="tax-fund-edit-dialog-fund-number-text"
          v-model.number="editedItem.commentCode"
          type="number"
          label="Comment Code"
          :rules="rules"
          @blur="somethingChanged"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
       <v-text-field
          id="taxCommentDescription"
          class="tax-fund-edit-dialog-fund-number-text"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.description"
          label="Description"
          @blur="somethingChanged"
        >
</v-text-field>
</v-col>
      <v-col cols="4">
        <v-text-field
          id="taxCommentComments"
          class="tax-fund-edit-dialog-default-mills-text"
          v-uppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.comment"
          label="Comments"
          @blur="somethingChanged"
          readonly tabindex="-1">
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'taxCommentEditItem',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxCommentTypes',
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'index', 'isVisible']),
    ...mapState({
      statusTypes: (state) => state.enums.taxCommentTypesStatusEnum || [],
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    rules() {
      return [
        () => {
          if (this.editedItem.commentCode >= 1 && this.editedItem.commentCode <= 10) {
            return 'Comment codes from 1-10 are reserved';
          }
          return true;
        },
      ];
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
  },
};
</script>
